import {UPDATE_VOD_RAILS} from '@/store/mutationTypes';

export default {
  [UPDATE_VOD_RAILS](state, data) {
    state.vodRails = data;
  },
};
